module.exports = __webpack_public_path__ + "img/072db8e0dd1c0a8301d16dedd3a51cd7.png";